import React, {useEffect, useState} from 'react';
import {QrCode} from "types/QrCode";
import ConfirmModal from "components/ConfirmModal";
import {invalidate} from "services/query-client";
import {useMutation} from "react-query";
import ngage from "services/ngage";

type Props = {
    qrCode: QrCode | null
    show: boolean
    onDelete?: (qrCode: QrCode) => any
    onDeleteFail?: (qrCode: QrCode, error: unknown) => any
    onCancel?: () => any
}

function DeleteQrCode(props: Props) {
    const {qrCode, show, onDelete, onDeleteFail, onCancel} = props

    const [name, setName] = useState<string>(qrCode?.name || 'this QR code');
    const {mutateAsync: deleteQrCode} = useMutation(ngage.qrCodes.destroy)

    useEffect(() => {
        if(qrCode) setName(qrCode.name)
    }, [qrCode]);

    async function handleDeleteQrCode() {
        if (qrCode) {
            try {
                await deleteQrCode(qrCode.id)
                await invalidate('qr-codes.all')

                if (onDelete) onDelete(qrCode)
            } catch (error) {
                if (onDeleteFail) onDeleteFail(qrCode, error)
            }
        }
    }

    function handleCancel() {
        if (onCancel) onCancel()
    }

    return (
        <ConfirmModal
            show={show}
            type={ConfirmModal.types.DANGER}
            title="Delete QR Code"
            body={`Are you sure you want to permanently delete '${name}'? This action cannot be undone.`}
            approveLabel="Delete"
            onApprove={handleDeleteQrCode}
            onCancel={handleCancel}
        />
    );
}

export default DeleteQrCode;